<template>
  <div>
    <template v-if="terms">
      <hr>
      <h4>Terms & Conditions</h4>
      <ul>
        <li
          v-for="term in terms.split(',')"
          :key="term"
          class="term"
        >
          {{ term }}.
        </li>
      </ul>
    </template>
    <template v-if="codehas.unLocked">
      <!--  Owner info -->
      <div class="pBy pl-1 hidden-screen-only d-print">
        Powered By: Rose-Finch | info.codehas@gmail.com | {{ version }}V
      </div>
    </template>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      terms: "",
      codehas: {
        encrypKey: "330505872085@codehas.com",
        current: null,
        ownerLicense: "",
        unLocked: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      overall: "configs/terms",
      version: "configs/version",
    }),
  },
  created() {
    Event.$on("loadTerms", (setTerms) => {
      const data = this.overall[setTerms];
      if (data !== "" || data !== null) {
        this.$data.terms = data;
      }
    });
  },
  mounted() {
    this.codehas.ownerLicense = this.overall.ownnerInfo;
    this.codehas.current = "@" + window.location.host + "@unlocked2020";
    if (this.codehas.ownerLicense !== null) {
      this.validateOwnerInfo();
    }
  },
  methods: {
    validateOwnerInfo() {
      const decryption = this.CryptoJS.AES.decrypt(
        this.codehas.ownerLicense,
        this.codehas.encrypKey
      ).toString(this.CryptoJS.enc.Utf8);
      if (decryption === this.codehas.current) {
        this.codehas.unLocked = false;
      }
    },
  },
};
</script>
